import api_comm from "./lib";

export default function auth() {
	const getSessionToken = () => {
		return performAuth.SessionToken;
	};

	const isLoggedIn = () => {
		return performAuth.isAuthenticated;
	};

	const login = (username, password) => {
		let data = {
			username: username,
			password: password,
		};
		api_comm("post", "/auth/api/v2/login", data, null)
			.then((response) => performAuth.signin(response))
			.catch((error) => {
				console.log("Error", error);
			})
			.finally(() => {
				console.log("Finally");
			});
	};

	const performAuth = {
		isAuthenticated: false,
		SessionToken: null,
		signin(cb) {
			if (cb.result == true) {
				performAuth.isAuthenticated = true;
			}
		},
		signout(cb) {
			performAuth.isAuthenticated = false;
			setTimeout(cb, 100);
		},
	};

	return {
		getSessionToken,
		isLoggedIn,
		login,
		performAuth,
	};
}
